import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ForumNewsItem from './ForumNewsItem';
import { GetForumBlockData } from '../../utils/api/services/forum';
import Preloader from '../../components/Preloader/Preloader';
import paths from '../../paths';

export default class ForumNews extends Component {

  constructor(props) {
    super(props);

    this.state = {
      lastTopics: [],
      isLoading: false,
    };
  }

  componentWillMount = () => {
    this.getForumLastTopics();
  };

  getForumLastTopics = () => {
    this.setState({ isLoading: true });
    GetForumBlockData()
      .then((result) => {
        this.setState({
          lastTopics: result,
        });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  render() {
    const { isLoading, lastTopics } = this.state;

    if (!lastTopics.length) {
      return (<React.Fragment />);
    }

    return (
      <div className="section">
        <div className="box -latest-entries">
          <div className="box-title">Новое в разделе Форум</div>

          <div className="latest-entries">
            {isLoading ? (
              <Preloader />
            ) : (
              lastTopics.map((item, idx) => <ForumNewsItem key={idx} item={item} />)
            )}
          </div>
        </div>

        <div className="section-more">
          <Link to={paths.advocates.forum} className="btn -more">
            Все материалы раздела Форум
          </Link>
        </div>
      </div>
    );
  }
}
